// Angular imports
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

// Common imports
import { IconConstants, Utils } from 'cc-common';

// Service imports
import { UserService } from '../../_services/data-services/user.service';
import { ServerErrorService } from '../../_services/shared-services/server-error.service';

// Model imports
import { ActionAccessListParameterDto } from '../../_models/action-access-list-parameter-dto';
import { ActionAccessResultDto } from '../../_models/action-access-result-dto';

@Component({
    selector: 'app-notes-icon',
    templateUrl: './notes-icon.component.html',
    styleUrls: ['./notes-icon.component.scss']
})
export class NotesIconComponent implements OnInit {
    @Input() title = 'Internal Notes';
    @Input() hasNotes: boolean;
    @Input() cssClass: string;
    @Input() mode: string; // allowed values are 'editorOnly' || 'viewerOnly' || null;
    @Input() actionCode: string;
    @Input() communityId: number;
    @Input() customerId: string;

    @Output() onNotesClick = new EventEmitter<void>();

    showNotesIcon = false;

    iconNotes: string;
    iconEmptyNotes: string;

    constructor(private readonly userService: UserService, private readonly errorService: ServerErrorService) {}

    ngOnInit() {
        this.iconNotes = `${IconConstants.NOTES_AVAILABLE} ${this.cssClass}`;
        this.iconEmptyNotes = `${IconConstants.NOTES_EMPTY} ${this.cssClass}`;

        if (Utils.isNullOrUndefined(this.mode)) {
            this.showNotesIcon = this.userService.isInternal();
            setTimeout(() => {
                if (Utils.notNullAndDefined(this.actionCode)) {
                    this.checkActionAccess();
                }
            }, 200);
        } else {
            this.showNotesIcon =
                Utils.equalsIgnoreCase(this.mode, 'viewerOnly') || Utils.equalsIgnoreCase(this.mode, 'editorOnly');
        }
    }

    onClick(): void {
        this.onNotesClick.emit();
    }

    private checkActionAccess(): void {
        const params: ActionAccessListParameterDto = new ActionAccessListParameterDto();
        params.communityId = Utils.notNullAndDefined(this.communityId) ? this.communityId : null;
        params.customerId = Utils.notNullAndDefined(this.customerId) ? this.customerId : null;
        params.clearCache = false;

        this.userService.getActionList(params).subscribe(
            (actions: ActionAccessResultDto[]) => {
                const actionIndex = actions.findIndex((r) => Utils.equalsIgnoreCase(r.code, this.actionCode));
                this.showNotesIcon = Utils.notEquals(actionIndex, -1);
            },
            (error) => {
                this.errorService.displayError(error);
            }
        );
    }
}
